import hu from './hu';
import { commonI18n } from '@shared';
import merge from 'deepmerge';

export default merge(commonI18n, { hu });
